import { initializeApp } from "firebase/app";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken } from "firebase/messaging";
import { getFunctions, httpsCallable } from "firebase/functions"; // 🔥 aggiunto

// 🔹 Configurazione del progetto Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBC5c1L5_qJys4GTpZlpiKE8CTS594VmbY",
  authDomain: "fantawwe-83b60.firebaseapp.com",
  projectId: "fantawwe-83b60",
  storageBucket: "fantawwe-83b60.firebasestorage.app",
  messagingSenderId: "63311062652",
  appId: "1:63311062652:web:07215f65df100293e84bf9",
  measurementId: "G-0D1LCK0NG8"
};

// 🔹 Inizializza Firebase
export const app = initializeApp(firebaseConfig);

// 🔹 Esporta i servizi principali
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const messaging = getMessaging(app);

// 🔹 Funzioni cloud (serve per mandare notifiche)
export const functions = getFunctions(app);
export const sendNotification = httpsCallable(functions, "sendNotification");

// 🔹 Esporta anche getToken (per generare token FCM lato client)
export { getToken };

export async function saveUserToken(userId) {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: "BHzOwkYtZxPMh1RC_lL_p0r7u-RTq_T4zKSpLwPYh1w9..." // la tua VAPID key
    });

    if (currentToken) {
      await setDoc(doc(db, "userTokens", userId), { token: currentToken });
      console.log("✅ Token salvato su Firestore:", currentToken);
    } else {
      console.log("⚠️ Nessun token disponibile (permessi non concessi)");
    }
  } catch (err) {
    console.error("❌ Errore salvataggio token:", err);
  }
}